import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import useGetAllEmployees from '../../hooks/useGetAllEmployees';

// Searchable single-employee picker. Value is the employee id; onChange receives
// (id, employee) so callers can also read name or other fields.
const EmployeeAutocomplete = ({
    value = '',
    onChange,
    onBlur,
    inputRef,
    error = false,
    disabled = false,
    placeholder = 'Search employee by name or ID',
    excludeUser = false,
    excludeIds = [],
    size = 'small',
}) => {
    const { data, isLoading, isError } = useGetAllEmployees(excludeUser);
    const employees = (data?.response_data ?? []).filter((emp) => !excludeIds.includes(emp.id));

    return (
        <Autocomplete
            options={employees}
            loading={isLoading}
            disabled={disabled}
            noOptionsText={isError ? 'Error Loading Data' : 'No employees found'}
            getOptionLabel={(emp) => `${emp.name} (${emp.id})`}
            isOptionEqualToValue={(option, selected) => option.id === selected.id}
            value={employees.find((emp) => String(emp.id) === String(value)) ?? null}
            onChange={(_, emp) => onChange?.(emp ? emp.id : '', emp)}
            onBlur={onBlur}
            size={size}
            renderInput={(params) => (
                <TextField {...params} inputRef={inputRef} placeholder={placeholder} error={error} />
            )}
        />
    );
};

export default EmployeeAutocomplete;
